const About = () => {
  return (
  <div>
      <h5>Version 1.0.0</h5>
      <a href="/">Go Back</a>
  </div>
  )
};

export default About;

